import { ComponentProps } from "react";
import { FieldErrorOrUndefined } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import { Field, FieldErrorText } from "shared/components/Spor";

export const FieldErrorMessage = ({
  field,
  ...rest
}: {
  field: FieldErrorOrUndefined;
} & ComponentProps<typeof Field>) => (
  <Field {...rest} invalid={!!field} data-testid="form-control-error-msg">
    <FieldErrorText>{field?.message}</FieldErrorText>
  </Field>
);
